module.exports = __webpack_public_path__ + "media/images/upload-image-440e3fc09a3e4ed266e58770e6ddcacf.png";